import { routes } from "../../../app/routes";

interface BreadcrumbProps {
  showHome: boolean;
  values: { label: string; url: string | null }[];
}

export function generateCalendarsBreadcrumbs(
  path: string,

): BreadcrumbProps {
  switch(path){
    case routes.calendar.index:
      return {
        showHome: true,
        values: [{ label: "Provider Calendar", url: null }],
      };
    case routes.calendar.location:
      return {
        showHome:true, 
        values: [{ label: "Location Calendar", url: null }]
      };
  
    default:
      return { showHome: false, values: [] }; 
    
  }
}

export default generateCalendarsBreadcrumbs;

